import React from 'react';
import MaterialTable from 'material-table';
import { Localization, getDelimiter } from '../../helpers/localization';
import moment from 'moment';

const Employees = (props) => {

    const { name, data, date, loading } = props

    const dateString = moment(date).isValid() ? moment(date).format('MMMM YYYY') : 'Total'
    const title = `${name} - ${dateString}`

    const options = {
        search: false,
        paging: false,
        maxBodyHeight: 360,
        minBodyHeight: 360,
        draggable: false,
        actionsColumnIndex: -1,
        exportButton: true,
        exportFileName: `analyse-${name}-${dateString}`,
        exportDelimiter: getDelimiter(),
        exportPdf: () => { }
    }

    const columns = [
        { title: 'Fournisseur', field: 'name', cellStyle: { minWidth: '200px' } },
        { title: '80%', field: 'number80' },
        { title: '90%', field: 'number90' },
        { title: '100%', field: 'number100' },
        { title: 'TS', field: 'numberTS' },
        { title: `Posé ${dateString}`, field: 'totalPosedMonth' },
    ]

    return (
        <MaterialTable
            options={options}
            columns={columns}
            title={title}
            localization={Localization}
            isLoading={loading}
            data={data}
        />
    )
}

export default Employees;